import styled from 'styled-components';
import { Modal } from '@interstate/components/Modal';

export const ContractFormTypeModalContainer = styled(Modal)`
    & .MuiDialogContent-root > .MuiBox-root {
        display: none;
    }
`;

export const ContractFormTypeBodyGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const ContractFormTypeSelectionGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
`;

export const ContractFormTypeOptionsBox = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ContractFormTypeOptionRow = styled.div`
    position: relative;
    padding: 1rem;
    border: 1px solid #b2b2b2;
    cursor: pointer;

    &:first-child {
        border-bottom: none;
        border-radius: 4px 4px 0 0;
    }

    &:last-child {
        border-radius: 0 0 4px 4px;
    }

    &.selectedOptionRow {
        background-color: #ebf6ff;
    }

    &.selectedOptionRow::before {
        content: '';
        position: absolute;
        top: -1px;
        bottom: -1px;
        left: -1px;
        width: 4px;
        background-color: #003468;
    }

    &:first-child.selectedOptionRow::before {
        border-radius: 4px 0 0 0;
    }

    &:last-child.selectedOptionRow::before {
        border-radius: 0 0 0 4px;
    }
`;
